import { map } from 'lodash-es'

const userEditorFormInitialValues = values => {
  if (!values) return { isActive: true, roleIds: [] }

  return {
    ...values,
    roleIds: map(values.roles, ({ id }) => String(id)),
  }
}

export default userEditorFormInitialValues
